import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-sprite-sheet-generator',
  templateUrl: './sprite-sheet-generator.component.html',
  styleUrl: './sprite-sheet-generator.component.scss'
})
export class SpriteSheetGeneratorComponent implements OnInit {

  // constructor(private spritesheet_Service:SpriteService){}

  @Input() spriteSheetUrl: string = '';

  @Input() id: string = '';
  @Output() framesReady = new EventEmitter<string[]>();


  frameWidth = 160;
  frameHeight = 90;
  columnCount = 10;

  async splitSpriteSheet() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });

    const image = await this.loadImage(this.spriteSheetUrl);
    image.setAttribute('crossorigin', 'anonymous');
    canvas.width = image.width;
    canvas.height = image.height;
    ctx?.drawImage(image, 0, 0);

    const frames = [];
    const rowCount = Math.ceil(image.height / this.frameHeight); // Correct calculation for rows

    for (let row = 0; row < rowCount; row++) {
      for (let col = 0; col < this.columnCount; col++) {
        const x = col * this.frameWidth;
        const y = row * this.frameHeight;
        const frame = ctx?.getImageData(x, y, this.frameWidth, this.frameHeight);

        const frameCanvas = document.createElement('canvas');
        frameCanvas.width = this.frameWidth;
        frameCanvas.height = this.frameHeight;
        const frameCtx = frameCanvas.getContext('2d', { willReadFrequently: true });
        if(frame && frameCtx)
        frameCtx.putImageData(frame, 0, 0);

        const frameUrl = frameCanvas.toDataURL('image/png');
        frames.push(frameUrl);
      }
    }
    this.framesReady.emit(frames); // Emit the frames as an array
  }

  loadImage(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute('crossorigin', 'anonymous');
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }

  ngOnInit() {
    this.splitSpriteSheet(); // Start the process when the component is initialized
  }
}
